<div mdbModal #verPedido="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Detalle Pedido {{movimiento?.folio}}
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="verPedido.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col mb-1" style="display: flex; justify-content: flex-end;">
                        <div class="leyenda mr-3">
                            <mdb-icon fas icon="circle" class="text-success"></mdb-icon><span> Atendido</span>
                        </div>
                        <div class="leyenda mr-3">
                            <mdb-icon fas icon="circle" class="text-danger"></mdb-icon><span> No atendido</span>
                        </div>
                        <div class="leyenda">
                            <mdb-icon fas icon="circle" class="text-warning"></mdb-icon><span> Cambiado</span>
                        </div>
                    </div>
                </div>

                <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

                <div class="table-responsive" *ngIf="listaMovimientos">

                    <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
                    </app-no-data-alert>

                    <table class="table table-striped table-hover table-sm align-middle"
                        *ngIf="listaMovimientos?.length > 0">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">Cod. Prod.</th>
                                <th scope="col" class="text-center">Descrip.</th>
                                <th scope="col" class="text-center">Formato</th>
                                <th scope="col" class="text-center">Cant. Original</th>
                                <th scope="col" class="text-center">Cant. Aprobada</th>
                                <th scope="col" class="text-center">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let mov of listaMovimientos">
                                <td class="text-center">{{mov.skuProducto}}</td>
                                <td class="text-center">{{mov.nombreProducto}}</td>
                                <td class="text-center">{{mov.nombreFormato}}</td>
                                <td class="text-center">{{mov.cantidad | numerico}}</td>
                                <td class="text-center">{{mov.cantidad_atendida | numerico}}</td>
                                <td class="text-center">
                                    <mdb-icon fas icon="circle" *ngIf="mov.estadoAtendido === 0" class="text-danger">
                                        No atendido
                                    </mdb-icon>
                                    <mdb-icon fas icon="circle" *ngIf="mov.estadoAtendido === 1" class="text-success">
                                        Atendido
                                    </mdb-icon>
                                    <mdb-icon fas icon="circle" *ngIf="mov.estadoAtendido === 2" class="text-warning">
                                        Cambiado
                                    </mdb-icon>
                                </td>
                            </tr>
                            <!-- <tr>
                                <td class="text-center">999999</td>
                                <td class="text-center">Producto 2</td>
                                <td class="text-center">Caja</td>
                                <td class="text-center">5</td>
                                <td class="text-center">5</td>
                                <td class="text-center">
                                    <mdb-icon fas icon="circle" class="text-success"></mdb-icon>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center">999999</td>
                                <td class="text-center">Producto 3</td>
                                <td class="text-center">Caja</td>
                                <td class="text-center">5</td>
                                <td class="text-center">5</td>
                                <td class="text-center">
                                    <mdb-icon fas icon="circle" class="text-danger"></mdb-icon>
                                </td>
                            </tr> -->
                        </tbody>
                        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                            *ngIf="listaMovimientos?.length > 0"></app-pagination>
                    </table>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="verPedido.hide()" mdbWavesEffect>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>